/* eslint-disable no-unused-expressions */
import React from "react";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/bootstrap.css";
import PhoneInput from "react-phone-input-2";
import { Card } from "react-bootstrap";
import HookForm from "../../components/hookForm/hookForm";
import { Controller } from "react-hook-form";
import TextField from "../../components/textField/textField";
import CustomButton from "../../components/customButton/customButton";
import CustomeSelect from "../../components/customSelect/customSelect";
import { RadioButton } from "../../components/radioButton/radioButton";
import CustomeShimer from "../../components/customeShimer/customeShimer";
import Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb";
// import "./updateUser.scss";
import Constant from "../../util/constant";

/**
 * A functional component that renders a form for updating user information.
 * @param {{object}} props - The props passed to the component.
 * @param {{function}} props.handleFormSubmit - The function to handle form submission.
 * @param {{function}} props.roleradioChangeHandler - The function to handle radio button change for role selection.
 * @param {{string}} props.isroleselect - The selected role value.
 * @param {{object}} props.components - The components for the custom select input.
 * @param {{object}} props.selectInputRef - The reference to the select input element.
 * @param {{function}} props.mobileradioChangeHandler - The function to handle radio button change for mobile login selection.
 * @
 */
const UpdateUserComponent = (props) => {
  const { t } = useTranslation();

  /**
   * Destructures the properties object and assigns the corresponding values to variables.
   * @param {{object}} props - The properties object containing the values to destructure.
   * @returns None
   */
  const {
    handleFormSubmit,
    roleradioChangeHandler,
    isroleselect,
    components,
    selectInputRef,
    mobileradioChangeHandler,
    isMobileselect,
    addUserForm,
    addUserDepotName,
    onChangeDriverDepot,
    onChangeMangerDepot,
    formatOptionLabel,
    setphoneNumberError,
    phoneNumberError,
    setphoneTouched,
    phoneTouched,
    innerPagetitle,
    phoneNumbers,
    sethomeDepot,
    createUserFunction,
    placeHolderShimer,
    backPageFunction,
    defaultValue,
    updateUserloaderButtonShow,
    fullnametextcount,
    handlefullnametextcount,
    emailtextcount,
    handleEmailtextcount,
    paynumbertextcount,
    handlePaynumbertextcount,
    setUpdateValue,
    setPhoneNumbers,
    setphoneisvalid,
    phoneisvalid,
    isDriverDepotName,
    test
  } = props;



  /**
   * Renders a form for creating users with various input fields and buttons.
   * @param {{string}} innerPagetitle - The title of the inner page.
   * @param {{function}} backPageFunction - The function to navigate back to the previous page.
   * @returns The JSX elements for the create users form.
   */
  return (
    <>
      <React.Fragment>
        <div className="page-content CreateUsersManagement">
          <Breadcrumbs
            breadcrumbMainTitle={false}
            breadcrumbInner={true}
            innerPagetitle={innerPagetitle}
            backPageFunction={backPageFunction}
          />
          <Card className="Main_Card Main_CreateUsers_Management">
            <Card.Body className="activeTabSupplier">
              <div className="Main_Card_Body">
                {/**
                 * Renders a form with various input fields and buttons for adding a user.
                 * @param {{defaultForm: object}} defaultForm - The default form values.
                 * @param {{string}} className - The CSS class name for the form.
                 * @param {{function}} onSubmit - The function to handle form submission.
                 * @param {{function}} init - The function to initialize the form.
                 * @returns The rendered form component.
                 */}
                <HookForm
                  defaultForm={{
                    fullname: setUpdateValue?.fullname,
                    email: setUpdateValue?.emailid,
                    paynumber: setUpdateValue?.payno,
                    phone: setUpdateValue?.phone.toString(),
                    role: isroleselect,
                    mobileLogin: isMobileselect,
                    depot: defaultValue,
                  }}
                  className="form-horizontal"
                  onSubmit={(e) => handleFormSubmit(e)}
                  init={(form) => {
                    createUserFunction(form);
                  }}
                >
                  {(formMethod) => {
                    return (
                      <>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("FULL_NAME")}</p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <TextField
                                formMethod={formMethod}
                                rules={addUserForm.fullname.validate}
                                name={addUserForm.fullname.name}
                                errors={formMethod?.formState.errors}
                                autoFocus={true}
                                required={false}
                                type="text"
                                placeholder={t("ENTER_FULL_NAME")}
                                textCountVisible={true}
                                textcount={fullnametextcount}
                                onChange={handlefullnametextcount}
                                textCountTotal={200}
                              />
                            </div>
                          </div>
                          <div className="col-md-6 ">
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">
                                  {t("EMAIL_ADDRESS")}
                                </p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <TextField
                                disabled={true}
                                formMethod={formMethod}
                                rules={addUserForm.email.validate}
                                name={addUserForm.email.name}
                                errors={formMethod?.formState.errors}
                                autoFocus={true}
                                required={false}
                                type="text"
                                placeholder={t("ENTER_EMAIL_ADDRESS")}
                                textCountVisible={true}
                                textcount={emailtextcount}
                                onChange={handleEmailtextcount}
                                textCountTotal={200}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 ">
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("PAY_NUMBER")}</p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <TextField
                                formMethod={formMethod}
                                rules={addUserForm.paynumber.validate}
                                name={addUserForm.paynumber.name}
                                errors={formMethod?.formState.errors}
                                autoFocus={true}
                                required={false}
                                type="text"
                                maxLength={5}
                                placeholder={t("ENTER_5_DIGIT_PAY_NUMBER")}
                                textCountVisible={true}
                                textcount={paynumbertextcount}
                                onChange={handlePaynumbertextcount}
                                textCountTotal={5}
                              />
                            </div>
                          </div>
                          <div className="col-md-6 ">
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">
                                  {t("Phone Number")}
                                </p>
                                <p className="requiredStyle">*</p>
                              </div>

                              <Controller
                                name={addUserForm.phone.name}
                                rules={addUserForm.phone.validate}
                                control={formMethod.control}
                                render={({ field: { onChange, value } }) => (
                                  <>
                                    <PhoneInput
                                      className={"phoneinput textField"}
                                      placeholder={"000 000 0000"}
                                      enableSearch={true}
                                      showDropdown={false}
                                      country={"us"}
                                      value={phoneNumbers}
                                      countryCodeEditable={false}
                                      isValid={(value, country) => {
                                        if (!phoneTouched) {
                                          return true;
                                        } else if (
                                          /^([0-9]{8,15})$/.test(value)
                                        ) {
                                          return true;
                                        } else {
                                          return false;
                                        }
                                      }}
                                      onChange={(e) => {
                                        onChange(e.toString());
                                        setPhoneNumbers(e);
                                        setphoneTouched(true);
                                        if (!phoneTouched) {
                                          return true;
                                        } else if (/^([0-9]{8,15})$/.test(e)) {
                                          setphoneNumberError("");
                                          setphoneisvalid(false);
                                        } else {
                                          if (e === "") {
                                            setphoneNumberError(
                                              t("PLEASE_ENTER_PHONE_NUMBER")
                                            );
                                            return;
                                          } else {
                                            setphoneNumberError(
                                              t(
                                                "PLEASE_ENTER_VALID_PHONE_NUMBER"
                                              )
                                            );
                                            setphoneisvalid(true);
                                            return;
                                          }
                                        }
                                      }}
                                    />
                                  </>
                                )}
                              />
                            </div>
                            {phoneNumberError !== "" && phoneTouched && (
                              <div className=" errorMsg show">
                                <span>{phoneNumberError}</span>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 ">
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("ROLE")}</p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <div className="RadioWrapper">
                                <div
                                  className="radio-btn-container"
                                  style={{ display: "flex" }}
                                >
                                  <Controller
                                    name={addUserForm.role.name}
                                    rules={addUserForm.role.validate}
                                    control={formMethod.control}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <>
                                        <RadioButton
                                          onChange={(e) => {
                                            roleradioChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="1"
                                          isSelected={
                                            isroleselect === Constant.GENERALKEYS.MANAGER
                                          }
                                          label={t("MANAGER")}
                                          value={t("MANAGER")}
                                          name="role"
                                        />

                                        <RadioButton
                                          onChange={(e) => {
                                            roleradioChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="2"
                                          isSelected={
                                            isroleselect === Constant.GENERALKEYS.DRIVER
                                          }
                                          label={t("DRIVER")}
                                          value={t("DRIVER")}
                                          name="role"
                                        />
                                      </>
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 ">
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">
                                  {t("MOBILE_LOGIN")}
                                </p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <div className="RadioWrapper MobileRadioWrapper">
                                <div
                                  className="radio-btn-container"
                                  style={{ display: "flex" }}
                                >
                                  <Controller
                                    name={addUserForm.mobileLogin.name}
                                    rules={addUserForm.mobileLogin.validate}
                                    control={formMethod.control}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <>
                                        <RadioButton
                                          onChange={(e) => {
                                            mobileradioChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="3"
                                          isSelected={isMobileselect === "yes"}
                                          label={t("YES")}
                                          value="yes"
                                          disabled={!isroleselect}
                                        />

                                        <RadioButton
                                          onChange={(e) => {
                                            mobileradioChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="4"
                                          isSelected={isMobileselect === "no"}
                                          label={t("No")}
                                          value="no"
                                          disabled={
                                            isroleselect === Constant.GENERALKEYS.DRIVER||
                                            !isroleselect
                                          }
                                        />
                                      </>
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 ">
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("DEPOT")}</p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <Controller
                                name={addUserForm.depot.name}
                                rules={addUserForm.depot.validate}
                                control={formMethod.control}
                                render={({ field: { onChange, value } }) => (
                                  <>
                                    <CustomeSelect
                                      ref={selectInputRef}
                                      closeMenuOnSelect={false}
                                      options={addUserDepotName}
                                      onChange={(item) => {
                                        isroleselect === Constant.GENERALKEYS.DRIVER
                                          ? onChangeDriverDepot(item)
                                          : onChangeMangerDepot(item);
                                        onChange(item);
                                      }}
                                      formatOptionLabel={formatOptionLabel}
                                      components={components}
                                      isDisabled={!isroleselect}
                                      // value={defaultValue}
                                      value={isroleselect === Constant.GENERALKEYS.DRIVER && defaultValue === null && !setUpdateValue?.homedepotid ? test : isroleselect ===  Constant.GENERALKEYS.MANAGER && defaultValue === null && setUpdateValue?.homedepotid ? test :  isroleselect === Constant.GENERALKEYS.DRIVER && test?.length > 1 ? defaultValue : defaultValue}
                                      isClearable={true}
                                      placeholder={t("SELECT")}
                                      className={
                                        isroleselect === Constant.GENERALKEYS.DRIVER
                                          ? "singleSelecter fullWidthSelect"
                                          : "multiSelecter fullWidthSelect"
                                      }
                                      isMulti={
                                        isroleselect === Constant.GENERALKEYS.DRIVER ? false : true
                                      }
                                    />
                                  </>
                                )}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="mt-3 d-flex FormButton">
                          <div className="wrapper-input">
                            {placeHolderShimer && <CustomeShimer />}
                            {console.log(`isroleselect ----->>>>`, phoneisvalid, isroleselect, phoneisvalid, formMethod?.formState.errors)}
                            <CustomButton
                              className="black-btn Fill_Button"
                              type="submit"
                              closeMenuOnSelect={false}
                              // disabled={
                              //   isroleselect === Constant.GENERALKEYS.DRIVER
                              //     ? !formMethod?.formState.isValid ||
                              //       phoneisvalid
                              //     : !formMethod?.formState.isValid ||
                              //       !sethomeDepot ||
                              //       phoneisvalid
                              // }
                              disabled={
                                isroleselect === Constant.GENERALKEYS.DRIVER
                                  ? !formMethod?.formState.isValid || !formMethod?.formState.isDirty ||  (paynumbertextcount < 5) || phoneisvalid || (isDriverDepotName === null || isDriverDepotName === '' || defaultValue === null)
                                  : !formMethod?.formState.isValid || !formMethod?.formState.isDirty || phoneisvalid || (paynumbertextcount < 5) ||
                                  (sethomeDepot === null || sethomeDepot === '') 
                              }
                              loading={updateUserloaderButtonShow}
                            >
                              {t("UPDATE")}
                            </CustomButton>
                          </div>
                          {console.log('formMethod', formMethod.getValues() )}
                        </div>
                      </>
                    );
                  }}
                </HookForm>
              </div>
            </Card.Body>
          </Card>
        </div>
      </React.Fragment>
    </>
  );
};

export default UpdateUserComponent;
